import { render, staticRenderFns } from "./preOrg.vue?vue&type=template&id=51a084e8&scoped=true&"
import script from "./preOrg.vue?vue&type=script&lang=js&"
export * from "./preOrg.vue?vue&type=script&lang=js&"
import style0 from "./preOrg.vue?vue&type=style&index=0&id=51a084e8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a084e8",
  null
  
)

export default component.exports